import React from 'react'
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"
import Errors from "../Errors/Errors"

export default class AcceptInvitation extends React.Component {
  
  constructor(props) {
    super(props)
    
    this.state = {
      errors: [],
      loading: false,
      password: '',
      password_confirmation: '',
      accept_terms: false,
      showPassword: false,
      showConfirmationPassword: false,
    }

    this.onClickTerms = this.onClickTerms.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onTogglePassword = this.onTogglePassword.bind(this);
  }

  render() {
    return (
      <form onSubmit={this.onSubmit} style={{position: 'relative'}}>
        <Errors errors={this.state.errors} />

        {
          this.props.user || this.props.customer
          ?
          this.renderForm()
          :
          <Errors errors={[I18n.t('invitation_token_used')]} />
        }

        <hr />

        <div><a href={this.props.sign_in_path}>{I18n.t('sign_in')}</a></div>

        <LoadingSpinner backgroundColor="rgba(32,33,46,0.5)" size="small" show={this.state.loading} />
      </form>
    )
  }

  renderForm() {
    return (
      <div className="set-password-form">
        <label className="password-rules-label">
          {I18n.t('password_must')}
        </label>
        <ul className="password-rules-list">
          <li>{I18n.t('be_8_characters')}</li>
          <li>{I18n.t('contain_lowercase')}</li>
          <li>{I18n.t('contain_uppercase')}</li>
          <li>{I18n.t('contain_number')}</li>
          <li>{I18n.t('contain_symbol')}</li>
        </ul>
        <div className="form-group">
          <label>{I18n.t('password')}</label>
          <div style={{position: "relative" }}>
            <input type={this.state.showPassword ? "text" : "password"} name="password" className="form-control" value={this.state.password} onChange={this.onChange} />
            <span
              className={`fa fa-fw ${
                this.state.showPassword ? "fa-eye fa-eye-slash" : "fa-eye"
              }`}
              onClick={() => this.onTogglePassword("showPassword")}
              style={{
                position: "absolute",
                cursor: "pointer",
                top: "11px",
                right: "6px",
                color: "#555",
              }}></span>
          </div>
        </div>

        <div className="form-group">
        <label>{I18n.t('password_confirmation')}</label>
        <div style={{position: "relative"}}>
          <input type={this.state.showConfirmationPassword ? "text" : "password"} name="password_confirmation" className="form-control" value={this.state.password_confirmation} onChange={this.onChange} />
          <span
            className={`fa fa-fw ${
              this.state.showConfirmationPassword ? "fa-eye fa-eye-slash" : "fa-eye"
            }`}
            onClick={() => this.onTogglePassword("showConfirmationPassword")}
            style={{
              position: "absolute",
              cursor: "pointer",
              top: "11px",
              right: "6px",
              color: "#555",
              }}></span>
          </div>
        </div>

        {
          this.props.user
          ?
          <div className="TermsAndConditions">
            <label><input type="checkbox" name="accept_terms" value={this.state.accept_terms} onClick={this.onClickTerms}/> <span dangerouslySetInnerHTML={{__html: I18n.t('i_agree_with_user_terms')}}></span></label>
          </div>
          :
          null
        }
        
        <div className="actions">
          <button type="submit" className="btn btn-primary" disabled={this.props.user && this.state.accept_terms == false}>{I18n.t('set_my_password')}</button>
        </div>
      </div>
    )
  }

  onClickTerms() {
    this.setState({
      accept_terms: !this.state.accept_terms
    })
  }

  onChange(e) {
    var { state } = this;
    state[e.target.name] = e.target.value
    this.setState(state);
  }

  onTogglePassword(passwordToggle) {
    if (passwordToggle === 'showPassword') {
      this.setState({showPassword: !this.state.showPassword});
    } else if (passwordToggle === 'showConfirmationPassword') {
      this.setState({showConfirmationPassword: !this.state.showConfirmationPassword});
    }
  }

  onSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    if (this.props.user || this.props.customer) {
      this.setState({loading: true})
      $.ajax({
        type: 'POST',
        url: this.props.path,
        data: {
          property_id: this.props.property ? this.props.property.id : null,
          token: this.props.token,
          password: this.state.password,
          password_confirmation: this.state.password_confirmation,
          accept_terms: this.accept_terms,
        }
      }).done((data) => {
        if (data.errors) {
          this.setState({errors: data.errors, loading: false})
        } else {
          //this.setState({errors: [], loading: false})
          window.location.href = data.redirect_to
        }
      });
    }
  }

};